<!-- Связанные ремонты и пометки с переходом к карточке на том же ТС -->
<template>
  <BaseFormSection v-if="records.length" :title="resource === 'repairs' ? 'Связанные ремонты' : 'Связанные пометки'"
    :icon="resource === 'repairs' ? 'wrench' : 'comment'" :count="records.length" :columns="1">
    <FleetRepairRemarkCard v-for="record in records" :key="record.id"
      :record="record" :resource="resource" :vehicle-id="vehicleId" />
  </BaseFormSection>
</template>
<script>
import FleetRepairRemarkCard from "@/components/Fleet/RepairRemark/Card.vue";

export default {
  name: "FleetRepairRemarkLinks",
  components: { FleetRepairRemarkCard },
  props: {
    records: { type: Array, default: () => [] },
    resource: { type: String, required: true },
    vehicleId: { type: [Number, String], required: true },
  },
};
</script>
